export default function Hero() {
  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const vimeoEmbedUrl =
    'https://player.vimeo.com/video/1170661020?autoplay=1&muted=1&loop=0&controls=0&background=1';

  return (
    <section className="flex flex-col bg-white pt-24">

      {/* トップ動画エリア */}
      <div className="w-full relative" style={{ paddingTop: '56.25%' }}>
        <iframe
          src={vimeoEmbedUrl}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow="autoplay; fullscreen; picture-in-picture"
          title="MAWARI動画"
        />
      </div>

      {/* テキスト・ボタンエリア */}
      <div className="flex flex-col justify-center px-6 sm:px-10 lg:px-20 py-12 w-full">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          <span className="block sm:inline">「わからない」が</span>
          <span className="block sm:inline">「楽しい」に変わる場所。</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-700 mb-2 font-medium">
          MAWARIノードオーナーのための、
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-8 font-medium">
          世界一やさしい冒険ガイド。
        </p>
        <p className="text-base md:text-lg text-gray-500 mb-12">
          暗号通貨初心者・シニアの方でも安心。ロッキング・リワード・最新技術ニュースまで、ここですべて学べます。
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap gap-4">
          <button
            onClick={() => handleNavigation('/locking')}
            className="px-8 py-4 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-base font-bold rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            🔐 ロッキングとは
          </button>
          <button
            className="px-8 py-4 bg-gray-100 text-gray-800 text-base font-bold rounded-full hover:bg-gray-200 hover:shadow-md hover:scale-105 transition-all border border-gray-200 whitespace-nowrap cursor-pointer"
          >
            🎁 リワード受け取り方法
          </button>
          <button
            onClick={() => handleNavigation('/security')}
            className="px-8 py-4 bg-gray-100 text-gray-800 text-base font-bold rounded-full hover:bg-gray-200 hover:shadow-md hover:scale-105 transition-all border border-gray-200 whitespace-nowrap cursor-pointer"
          >
            🛡 セキュリティ完全ガイド
          </button>
          <button
            onClick={() => handleNavigation('/news')}
            className="px-8 py-4 bg-gray-100 text-gray-800 text-base font-bold rounded-full hover:bg-gray-200 hover:shadow-md hover:scale-105 transition-all border border-gray-200 whitespace-nowrap cursor-pointer"
          >
            📰 最新ニュースを見る
          </button>
        </div>
      </div>
    </section>
  );
}
